import { EventCategory } from '../types/eventsTypes';

export const eventsCategories: Record<EventCategory, string> = {
  CREDIT_ANALYSIS: 'Credit analysis',
  ESG_ANALYSIS: 'ESG analysis',
  FUNDS_ANALYSIS: 'Funds analysis',
};
